<template>
  <div class="type-p">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form :model="queryParams" ref="queryForm" :inline="true">
        <el-form-item label="平台渠道" prop="status">
          <el-select
            clearable
            v-model="queryParams.platNo"
            placeholder="分类状态"
            size="small"
          >
            <el-option
              v-for="dict in platOptions"
              :key="dict.dictValue"
              :label="dict.dictLabel"
              :value="dict.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称" prop="platName">
          <el-input
            v-model="queryParams.platName"
            placeholder="请输入分类名称"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select
            clearable
            v-model="queryParams.status"
            placeholder="分类状态"
            clearable
            size="small"
          >
            <el-option
              v-for="dict in statusOptions"
              :key="dict.dictValue"
              :label="dict.dictLabel"
              :value="dict.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            size="small"
            @click="loadData"
            type="primary"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="small" @click="resetQuery"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="table-body">
      <div style="overflow:hidden;margin: 0 0 16px 0;">
        <el-button
          size="small"
          type="primary"
          @click="handleAdd"
          >新增</el-button
        >
      </div>
      <el-table
        :data="tableData"
        class="border"
        row-key="platId"
        :tree-props="{ children: 'children' }"
      >
        <el-table-column label="分类名称" prop="platName" />
        <el-table-column label="英文名称" prop="engPlatName" />
        <el-table-column label="分类编号" prop="platCode" />
        <el-table-column
          label="所属平台"
          prop="platNo"
          :formatter="platNoFormat"
        />
        <el-table-column label="排序" prop="orderNum" />
        <el-table-column prop="status" label="状态" :formatter="statusFormat" />
        <el-table-column label="创建时间" prop="createTime">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="updateTime" align="center">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.updateTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left">
          <template slot-scope="scope">
            <div>
              <el-button
                size="mini"
                type="text"
                @click="handleUpdate(scope.row)"
                >修改</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleAdd(scope.row)"
                v-if="scope.row.isLeaf == '0'"
                >新增</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :close-on-click-modal="false"  
      class="type-edit-dialog"
      :title="title"
      :visible.sync="open"
      width="600px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        :rules="rules"
        style="margin: 15px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属平台：" prop="platNo">
              <el-select
                clearable
                v-model="form.platNo"
                placeholder="所属平台"
                clearable
                size="small"
                :disabled="!isTopPlatType"
              >
                <el-option
                  v-for="dict in platOptions"
                  :key="dict.dictValue"
                  :label="dict.dictLabel"
                  :value="dict.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上级类目：" prop="pPlatId" class="tree-sel">
              <treeselect
                class="type-sel"
                v-model="form.pPlatId"
                :options="platTypeOptions"
                :normalizer="normalizer"
                :show-count="true"
                placeholder="选择上级分类"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类目编号：" prop="platCode">
              <el-input
                size="small"
                v-model="form.platCode"
                placeholder="请输入类目编号或点击自动生成"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类目名称：" prop="platName">
              <el-input
                size="small"
                v-model="form.platName"
                placeholder="请输入类目名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="英文名称：" prop="engPlatName">
              <el-input
                size="small"
                v-model="form.engPlatName"
                placeholder="请输入英文名称"
                maxlength="20"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="显示排序：" prop="orderNum">
              <el-input-number
                size="small"
                v-model="form.orderNum"
                controls-position="right"
                :min="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="分类状态：">
              <el-radio-group v-model="form.status">
                <el-radio
                  size="small"
                  v-for="dict in statusOptions"
                  :key="dict.dictValue"
                  :label="dict.dictValue"
                  >{{ dict.dictLabel }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <span slot="label">
                <span>
                  <span> 叶子节点：</span>
                  <span title="属于叶子节点的类目不可以添加下一级类目">
                    <svg-icon icon-class="tip" />
                  </span>
                </span>
              </span>
              <el-radio-group v-model="form.isLeaf">
                <el-radio
                  size="small"
                  v-for="dict in nodeTypeOptions"
                  :key="dict.dictValue"
                  :label="dict.dictValue"
                  >{{ dict.dictLabel }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.isLeaf == '1'">
            <el-form-item label="产品类型" prop="feedProductType">
              <el-input
                size="small"
                v-model="form.feedProductType"
                placeholder="请输入产品类型"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.isLeaf == '1'">
            <el-form-item label="分类目录" prop="itemType">
              <el-input
                size="small"
                v-model="form.itemType"
                placeholder="请输入分类目录"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  addPlatType,
  updatePlatType,
  delPlatType,
  listPlatType,
  getProductTypeList,
} from "@/api/plat/platType"
import Treeselect from "@riophae/vue-treeselect"
import "@riophae/vue-treeselect/dist/vue-treeselect.css"
export default {
  name: "platType",
  components: { Breadcrumb, Treeselect },
  data() {
    return {
      queryParams: {
        platNo: undefined,
        platName: undefined,
        status: undefined,
      },
      form: {
        platNo: undefined, //所属平台
        platCode: undefined, //类目编码
        pPlatId: undefined,
        platName: undefined, //中文名称，
        engTypeName: undefined, //英文名称
      },
      platOptions: [], //平台列表
      platTypeOptions: [], //分类选择树
      tableData: [],
      statusOptions: [],
      nodeTypeOptions: [], //节点类型（是否叶子节点）
      open: false,
      title: "",
      // 表单校验
      rules: {
        platName: [
          { required: true, message: "类目名称不能为空", trigger: "blur" },
        ],
        platCode: [
          { required: true, message: "类目编号不能为空", trigger: "blur" },
        ],
        orderNum: [
          { required: true, message: "类目顺序不能为空", trigger: "blur" },
        ],
      },
      isTopPlatType: false, //是否顶级类目
      loading: false,
    }
  },
  created() {
    this.loadData()
    this.getDicts("sys_normal_disable").then((response) => {
      this.statusOptions = response.data
    })
    this.getDicts("sys_tree_node_type").then((response) => {
      this.nodeTypeOptions = response.data
    })
    this.getDicts("s_plat_code").then((response) => {
      this.platOptions = response.data
    })
  },
  methods: {
    loadData() {
      this.loading = true
      getProductTypeList(this.queryParams)
        .then((response) => {
          response.data.map((item) => {
            item.children = item.childrenTree
          })
          this.tableData = response.data
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    resetQuery() {
      this.$refs["queryForm"].resetFields()
    },
    handleUpdate(row) {
      this.reset()
      this.getTreeSelect()
      this.form = JSON.parse(JSON.stringify(row))
      this.open = true
      this.title = "修改类目"
    },
    handleAdd(row) {
      this.reset()
      this.getTreeSelect()
      if (row != null && row.platId) {
        this.form.pPlatId = row.platId
        this.form.platNo = row.platNo
        this.isTopPlatType = false
      } else {
        this.form.pPlatId = 0
        this.isTopPlatType = true
      }
      this.open = true
      this.title = "添加类目"
    },
    handleDelete(row) {
      this.$confirm("确定要删除类目「" + row.platName + "」吗？", "警告", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          return delPlatType(row.platId)
        })
        .then((res) => {
          if (res.code == 200) {
            this.loadData()
            this.$message.success("删除成功")
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((err) => {})
    },
    /** 转换分类数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.platId,
        label: node.platName,
        children: node.childrenTree,
      }
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.platId != undefined) {
            updatePlatType(this.form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess("修改成功")
                this.open = false
                this.loadData()
              }
            })
          } else {
            addPlatType(this.form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess("新增成功")
                this.open = false
                this.loadData()
              }
            })
          }
        }
      })
    },
    cancel() {
      this.open = false
      this.reset()
    },
    // 分类状态字典翻译
    statusFormat(row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    platNoFormat(row, column) {
      return this.selectDictLabel(this.platOptions, row.platNo)
    },
    getTreeSelect() {
      this.platTypeOptions = []
      listPlatType().then((response) => {
        let type = { platId: 0, platName: "主类目", childrenTree: [] }
        type.childrenTree = response.rows
        this.platTypeOptions.push(type)
      })
    },
    // 表单重置
    reset() {
      this.form = {
        platId: undefined,
        pPlatId: 0,
        engPlatName: undefined,
        platCode: undefined,
        orderNum: undefined,
        status: "0",
        isLeaf: "0",
      }
      this.resetForm("form")
    },
  },
}
</script>
